module.exports = __webpack_public_path__ + "img/reward-1.76ad83cb.png";